import Api from './api'
import App from './app'
import Auth from './auth'

export default {
    app: App,
    api: Api,
    auth: Auth,
}
